/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_Awaiting_DocsInputs */

const en_cases_filter_awaiting_docs = /** @type {(inputs: Cases_Filter_Awaiting_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting docs`)
};

const pt_br2_cases_filter_awaiting_docs = /** @type {(inputs: Cases_Filter_Awaiting_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguardando docs`)
};

/**
* | output |
* | --- |
* | "Awaiting docs" |
*
* @param {Cases_Filter_Awaiting_DocsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_awaiting_docs = /** @type {((inputs?: Cases_Filter_Awaiting_DocsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_Awaiting_DocsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_awaiting_docs(inputs)
	return pt_br2_cases_filter_awaiting_docs(inputs)
});